import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { VatCodeEntity } from "../../types/VatCodeEntity";
import { VatCodeDtoToEntity } from "../mappers/VatCodeDtoToEntity";
import { VatCodeEntityToDto } from "../mappers/VatCodeEntityToDto";

const VatCodeApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        VatCodeLoad: builder.query<VatCodeEntity, FormQuery>({
            providesTags: [ResourceName.VAT_CODES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.VAT_CODES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return VatCodeDtoToEntity(response);
            },
        }),
        VatCodeSave: builder.mutation<VatCodeEntity, FormMutation<VatCodeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.VAT_CODES}`;
                const method = "POST";

                const body = VatCodeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.VAT_CODES],
        }),
        VatCodeUpdate: builder.mutation<VatCodeEntity, FormMutation<VatCodeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.VAT_CODES}/${mutation.data.id}`;
                const method = "PUT";

                const body = VatCodeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.VAT_CODES],
        }),
    }),
});

export const { useVatCodeLoadQuery, useVatCodeSaveMutation, useVatCodeUpdateMutation } = VatCodeApi;
